import React, { useState } from "react";
import styled from "styled-components";

const KeyboardContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(10, 1fr);  /* 每行7個按鍵，減少每行的按鈕數量 */
  gap: 8px;  /* 增加按鍵之間的間距 */
  padding: 15px;
  background-color: #e1f2ff;
  border: 1px solid #ddd;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  max-width: 100%;
  width: 90%;
  box-sizing: border-box;

  /* 保證鍵盤高度不會過小 */
  height: 40vh;  /* 鍵盤高度設定為螢幕高度的25% */
`;

const KeyButton = styled.button`
  padding: 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  background-color: #f0f0f0;
  text-align: center;

  &:hover {
    background-color: #e0e0e0;
  }

  &:active {
    background-color: #ccc;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 16px; /* 根據螢幕大小調整按鈕的大小 */
  }

  @media (max-width: 375px) {
    font-size: 14px;
    padding: 12px;
  }
`;

const VirtualKeyboard = ({ onKeyPress }) => {
  const [isShiftActive, setIsShiftActive] = useState(false);  // 用來控制 Shift 是否啟用

  const toggleShift = () => {
    setIsShiftActive(!isShiftActive);  // 切換 Shift 狀態
  };

  // 字母和符號的列表
  const keys = "1234567890abcdefghijklmnopqrstuvwxyz!@#$%^&*()".split("");

  const handleKeyPress = (char) => {
    if (isShiftActive && /[a-z]/i.test(char)) {
      // 如果 Shift 啟用，且按鍵是字母，轉換成大寫
      onKeyPress(char.toUpperCase());
    } else {
      onKeyPress(char);
    }
  };

  return (
    <KeyboardContainer>
      {keys.map((char) => (
        <KeyButton key={char} onClick={() => handleKeyPress(char)}>
          {isShiftActive && /[a-z]/i.test(char) ? char.toUpperCase() : char} {/* 根據 Shift 狀態顯示大寫或小寫字母 */}
        </KeyButton>
      ))}
      <KeyButton onClick={toggleShift}>{isShiftActive ? "⇧" : "shift"}</KeyButton> {/* 顯示 Shift 鍵 */}
      <KeyButton onClick={() => onKeyPress("delete")}>刪除</KeyButton>
      <KeyButton onClick={() => onKeyPress("clear")}>清除</KeyButton>
    </KeyboardContainer>
  );
};

export default VirtualKeyboard;
